import React, { useState, useRef, useEffect } from 'react';

const LazyImage = ({ src, alt, className, fallbackSrc = '/Images/background.jpg' }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isInView, setIsInView] = useState(false);
    const [hasError, setHasError] = useState(false);
    const imgRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.1,
                rootMargin: '50px'
            }
        );

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    const handleImageError = () => {
        setHasError(true);
        setIsLoaded(true);
    };

    return (
        <div ref={imgRef} className={`relative overflow-hidden ${className}`}>
            {/* Skeleton/Loading placeholder */}
            {!isLoaded && (
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse">
                    <div className="flex items-center justify-center h-full">
                        <div className="text-gray-400 text-sm">Loading...</div>
                    </div>
                </div>
            )}

            {/* Actual image */}
            {isInView && (
                <img
                    src={hasError ? fallbackSrc : src}
                    alt={alt}
                    className={`w-full h-full object-cover transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'
                        }`}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                />
            )}

            {/* Fade-in overlay effect */}
            <div
                className={`absolute inset-0 bg-white transition-opacity duration-500 ${isLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'
                    }`}
            />
        </div>
    );
};

export default LazyImage;
